<template>
  <v-card id="top-page" style="background-color: #eef2f5; max-height: 100vh">
    <v-card
      class="container_main d-flex align-center justify-content-end rounded-0 bg"
      width="100vw"
      min-height="100vh"
      style="justify-content: end"
    >
      <v-card
        class="pa-10 d-flex flex-column align-center justify-space-between rounded-xl mt-5 mr-20"
        style="background-color: rgba(255, 255, 255, 0.8)"
        width="400px"
        height="auto"
      >
        <h2>Service Request</h2>
        <div
          style="width: 100%"
          class="d-flex flex-column align-center justify-space-between"
        >
          <v-text-field
            name="input-10-2"
            :label="'Name ' + '*'"
            value=""
            light
            v-model="userInfo.name"
            class="input-group--focused"
            :rules="[rules.required, rules.min]"
            style="width: 100%"
            color="#333333"
          />

          <v-text-field
            name="input-10-2"
            :label="'Email ' + '*'"
            v-model="userInfo.email"
            value=""
            class="input-group--focused"
            :rules="[rules.required, rules.min]"
            style="width: 100%"
            color="#333333"
          />

          <v-text-field
            name="input-10-2"
            :label="'Phone ' + '*'"
            v-model="userInfo.phone"
            value=""
            class="input-group--focused"
            :rules="[rules.required, rules.min]"
            style="width: 100%"
            color="#333333"
          />

          <v-text-field
            name="input-10-2"
            :label="'Company name ' + '*'"
            v-model="userInfo.company"
            value=""
            class="input-group--focused"
            :rules="[rules.required, rules.min]"
            style="width: 100%"
            color="#333333"
          />

          <v-text-field
            name="input-10-2"
            :label="'Equipment ID ' + '*'"
            v-model="userInfo.equipment"
            value=""
            class="input-group--focused"
            :rules="[rules.required, rules.min]"
            style="width: 100%"
            color="#333333"
          />

          <v-text-field
            name="input-10-2"
            :label="'Equipment Serial Number ' + '*'"
            v-model="userInfo.equipment_serial"
            :rules="[rules.required, rules.min]"
            value=""
            class="input-group--focused"
            style="width: 100%"
            color="#333333"
          />

          <v-text-field
            name="input-10-2"
            :label="'Comments ' + '*'"
            v-model="userInfo.comment"
            value=""
            class="input-group--focused"
            :rules="[rules.required, rules.min]"
            style="width: 100%"
            color="#333333"
          />
          <v-switch
            v-model="isTest"
            style="margin-bottom: 7px; margin-top: 0;"
            hide-details
            label="Live/Test"
          ></v-switch>
          <div
            v-if="isError"
            class="d-flex justify-start"
            style="width: 100%; color: red"
          >
            <h5>*Please fill in all information</h5>
          </div>
          <div style="width: 100%" class="d-flex align-center justify-center">
            <g-recaptcha
              style="width: 100%"
              data-sitekey="6LcEqtQlAAAAAGHpVRo-Yb6sVo0o_3fa9jT2qhoP"
              class="input-group--focused d-flex justify-center"
              :data-validate="validate"
              :data-callback="callback"
            >
              <v-btn
                elevation="2"
                min-width="150px"
                :loading="loader"
                :disabled="loading"
                @click="loader = 'loading'"
                class="button-submit input-group--focused"
                >Submit Request</v-btn
              >
            </g-recaptcha>
          </div>
          <div class="GotoLogin">
            <a class="switchTabMsg" @click="gotoLogin"
              >Already have an account? Log in</a
            >
          </div>
        </div>
      </v-card>
    </v-card>
  </v-card>
</template>
<script>
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";
import DecodeJWT from "../DecodeJWT";
import { mapGetters } from "vuex";
export default {
  components: {
    gRecaptcha,
  },
  mounted() {
    let token = localStorage.getItem("token");
    if (token != "") {
      var info = DecodeJWT(token);
      if (info.exp > new Date().getTime() / 1000) {
        this.$router.push("/home");
      }
    }
  },
  data() {
    return {
      isError: false,
      userInfo: {
        name: "",
        email: "",
        phone: "",
        company: "",
        equipment: "",
        equipment_serial: "",
        comment: "",
      },
      loading: false,
      isTest: false,
      loader: null,
      loadata: false,
    };
  },
  computed: {
    ...mapGetters("User", ["getCase", "getIsDone"]),
    rules() {
      return {
        required: (value) => !!value || this.$t("required"),
        min: (v) => v.length >= 0 || this.$t("hintPasswordField"),
        emailMatch: () => this.$t("emailMatch"),
        passwordMatch: (v) =>
          this.userPassword === v || this.$t("passwordMatch"),
      };
    },
  },
  watch: {
    getIsDone() {
      if (this.getIsDone == true) {
        this.$store.dispatch("User/setIsDoneFalse");
        this.loader = null;
      }
    },
    isTest() {
      localStorage.setItem("Test", this.isTest);
    },
    getCase() {
      if (this.getCase) {
        alert(
          "Thanks for your inquiry, our customer support will get in touch with you as soon as possible. Your ticket number is " +
            this.getCase +
            "."
        );

        this.userInfo = {
          name: "",
          email: "",
          phone: "",
          company: "",
          equipment: "",
          equipment_serial: "",
          comment: "",
        };
      }
    },
  },
  methods: {
    gotoLogin() {
      this.$router.push("/login");
    },
    validate() {
      return true;
    },
    async callback(token) {
      if (token) {
        if (
          this.userInfo.name != "" &&
          this.userInfo.phone != "" &&
          this.userInfo.email != "" &&
          this.userInfo.equipment != "" &&
          this.userInfo.equipment_serial != "" &&
          this.userInfo.company != "" &&
          this.userInfo.comment
        ) {
          let userInput = {
            userName: this.userInfo.name,
            userPhone: this.userInfo.phone,
            userEmail: this.userInfo.email,
            equipment: this.userInfo.equipment,
            equipment_serial: this.userInfo.equipment_serial,
            userCompany: this.userInfo.company,
            company_address: "",
            comment: this.userInfo.comment,
          };
          this.isError = false;
          await this.$store.dispatch("User/register", {
            user: userInput,
          });
        } else {
          this.isError = true;
        }
      } else {
        alert("Please check you are not robot!!!");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.mr-20 {
  margin-right: 10%;
}

.GotoLogin {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.switchTabMsg {
  text-align: center;
  width: fit-content;
  color: black !important;
  text-decoration: underline;
  font-size: 0.8rem;
}

.justify-content-end {
  justify-content: end;
}

.card_request_div_container {
  width: 40%;
  display: flex;
  max-height: 100vh;
  justify-content: center;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}

.v-expansion-panel::before {
  box-shadow: none;
}

.justify-space-between {
  justify-content: center;
}

.button-submit {
  width: 100%;
  padding-top: 0.625rem;
  background-color: transparent;
  color: #1a535e;
  border-radius: 2em;
  border-width: 2px;
  background: 0 0;
  font-weight: bold;
}

.bg {
  flex-wrap: wrap;
  background-size: cover;
  background-image: url("https://www.datavtech.com/wp-content/uploads/2022/11/Contact-us.png?id=468");
  background-color: #eef2f5;
}

.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.mb-20 {
  margin-bottom: 50px;
}

.table-custom {
  width: 100%;
  margin-top: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.input-search {
  margin-top: 5px;
  margin-bottom: 5px;
  border-style: solid;
  outline: #1a535e;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}
</style>
